import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getWorkFlow } from "../../store/workFlow/actions";
export var useGetWokFlow = function (trigger, workFlowId, onResetTrigger) {
    if (trigger === void 0) { trigger = false; }
    if (workFlowId === void 0) { workFlowId = ""; }
    var dispatch = useDispatch();
    var validWorkFlowId = (workFlowId !== null && workFlowId !== void 0 ? workFlowId : "").trim();
    var _a = useSelector(function (state) {
        var _a;
        return ({
            loadingWorkFlow: state.WorkFlow.loadingWorkFlow,
            responseWorkFlow: (_a = state.WorkFlow.responseWorkFlow) === null || _a === void 0 ? void 0 : _a.data,
            errorWorkflow: state.WorkFlow.errorWorkflow,
        });
    }), loadingWorkFlow = _a.loadingWorkFlow, responseWorkFlow = _a.responseWorkFlow, errorWorkflow = _a.errorWorkflow;
    useEffect(function () {
        if (!trigger || !validWorkFlowId)
            return;
        dispatch(getWorkFlow({
            id: workFlowId,
        }));
        if (onResetTrigger)
            onResetTrigger();
    }, [trigger, dispatch, workFlowId]);
    return {
        loadingWorkFlow: loadingWorkFlow,
        responseWorkFlow: responseWorkFlow,
        errorWorkflow: errorWorkflow,
    };
};
// ($64, 546.0);
